import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import "./campaign_configuration.css";

import { useLocation, useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import moment from "moment";
import { fetchUserById } from "../../../store/userMgmt";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigData,
  ConfigDataForCampaignCategory,
  ConfigDataForEarningLimitPeriod,
  ConfigDataForGlobalConfig,
  ConfigDataForModuleConfiguration,
  ConfigDataForRewardProvider,
} from "./configData";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { Dialog } from "@progress/kendo-react-dialogs";
import { deleteCampaignCategoryById, deleteCampaignRewardProviderById, fetchCampaignCategoryList, fetchEarningLimitPeriodList, fetchGlobalConfigList, fetchModuleConfigurationList, fetchRewardProviderList, updateCampaignCategoryStatus, updateEarningLimitPeriodStatus, updateModuleConfigurationStatus } from "../../../store/campaign_configuration";
import { ADMIN_TOOLS_CAMPAIGN_CATEGORY_CREATE, ADMIN_TOOLS_CAMPAIGN_CONFIGURATION_LIST, ADMIN_TOOLS_CAMPAIGN_GLOBAL_CONFIG, ADMIN_TOOLS_CAMPAIGN_REWARD_PROVIDER_CREATE } from "../../../routes";


export const REWARD_CONFIGURATION_TABS = {
  MODULE_CONFIGURATION: "Module Configuration",
  REWARDS_PROVIDER: "Rewards Provider",
  CAMPAIGN_CATEGORY: "Campaign Category",
  EARNING_LIMIT_PERIOD: "Earning Limit Period",
  GLOBAL_CONFIG: "Global Config"
};


export const CampaignConfigurationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const [selectedTab, setSelectedTab] = useState(
    query.get("tab") || ""
  );

  const [tab, setTab] = useState(REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION);
  const [moduleConfigurationList, setModuleConfigurationList] = useState([]);
  const [rewardProviderList, setRewardProviderList] = useState([]);
  const [campaignCategoryList, setCampaignCategoryList] = useState([]);
  const [earningLimitPeriodList, setEarningLimitPeriodList] = useState([]);
  const [globalPeriodList, setGlobalPeriodList] = useState([]);

  const [tabStatus, setTabStatus] = useState("");

  const [loading, setLoading] = useState([]);
  const [showUpdateStatus, setShowUpdateStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");

  const [tempId, setTempId] = useState("");
  const [actionID, setActionID] = useState("");
  const [actionType, setActionType] = useState("");

  const [showDelete, setShowDelete] = useState(false);


  const userPermissions = getUserPermission();
  const AddPermssion = checkPermission(
    userPermissions,
    "admin_tools.update_campaign_configuration"
  ) || false;

  const viewPermssion = checkPermission(
    userPermissions,
    "admin_tools.update_campaign_configuration"
  );

  const getData = async () => {
    setLoading(true);

    if (tab == REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION) {
      dispatch(fetchModuleConfigurationList()).then((res) => {
        setLoading(false);

        const formattedData = res.payload.data.map(item => ({
          ...item,
          status: item.is_active ? "Active" : "Inactive",
          id: item.sk
        }));

        setModuleConfigurationList(formattedData);


      });
    } else if (tab == REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER) {
      dispatch(fetchRewardProviderList()).then((res) => {
        setLoading(false);

        const formattedData = res.payload.data.map(item => ({
          ...item,
          image: item.image_url,
          id: item.pk
        }));

        setRewardProviderList(formattedData);


      });
    } else if (tab == REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY) {
      dispatch(fetchCampaignCategoryList()).then((res) => {
        setLoading(false);

        const formattedData = res.payload.data.map(item => ({
          ...item,
          status: item.is_active ? "Active" : "Inactive",
          id: item.sk
        }));

        setCampaignCategoryList(formattedData);


      });
    } else if (tab == REWARD_CONFIGURATION_TABS.EARNING_LIMIT_PERIOD) {
      dispatch(fetchEarningLimitPeriodList()).then((res) => {
        setLoading(false);

        const formattedData = res.payload.data.map(item => ({
          ...item,
          status: item.is_active ? "Active" : "Inactive",
          id: item.sk
        }));

        setEarningLimitPeriodList(formattedData);


      });
    } else if (tab == REWARD_CONFIGURATION_TABS.GLOBAL_CONFIG) {
      dispatch(fetchGlobalConfigList()).then((res) => {
        setLoading(false);

        const formattedData = [
          {
            id: "limit",
            max_coupons: res.payload.data.MAX_COUPONS.value,
            reset_period_month: res.payload.data.RESET_PERIOD_MONTHS.value

          }
        ]

        setGlobalPeriodList(formattedData);

      });
    }

  };

  useEffect(() => {
    getData();
  }, [tab]);

  useEffect(() => {
    if (!selectedTab) return;

    const tabMap = {
      module_configuration: REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION,
      reward_provider: REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER,
      campaign_category: REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY,
      earning_limit_period: REWARD_CONFIGURATION_TABS.EARNING_LIMIT_PERIOD,
      global_config: REWARD_CONFIGURATION_TABS.GLOBAL_CONFIG,
    };

    setTab(tabMap[selectedTab] || REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION);
  }, [selectedTab]);




  const actionTrigger = () => {
    setLoading(true);
    if (actionType === "Delete") {
      setShowDelete(false);

      if (tab == REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER) {
        dispatch(deleteCampaignRewardProviderById(actionID)).then((res) => {
          getData();

        });
      } else if (tab == REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY) {
        dispatch(deleteCampaignCategoryById(actionID)).then((res) => {
          getData();

        });
      }

    }
  };



  const handleTableClick = (type, id) => {
    if (type === "View Details") {
      navigate(`${ADMIN_TOOLS_CAMPAIGN_REWARD_PROVIDER_CREATE}?id=${id}`);
    } else if (type === "Delete") {
      setActionID(id);
      setActionType(type);
      if (type === "Delete") {
        setShowDelete(true);
      }
    }
    else if (type == "Edit") {

      if (tab == REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER) {
        navigate(`${ADMIN_TOOLS_CAMPAIGN_REWARD_PROVIDER_CREATE}?id=${id}`);

      } else if (tab == REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY) {
        navigate(`${ADMIN_TOOLS_CAMPAIGN_CATEGORY_CREATE}?id=${id}`);

      } else if (tab == REWARD_CONFIGURATION_TABS.GLOBAL_CONFIG) {
        navigate(`${ADMIN_TOOLS_CAMPAIGN_GLOBAL_CONFIG}?id=${id}`);

      }
    }
    else {
      if (tab == REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION) {
        const data = moduleConfigurationList.find(item => item.id === id);

        setTempId(data.id);
        setTempStatus(data.status);
        setShowUpdateStatus(true);
      } else if (tab == REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY) {
        const data = campaignCategoryList.find(item => item.id === id);

        setTempId(data.id);
        setTempStatus(data.status);
        setShowUpdateStatus(true);
      }
      else if (tab == REWARD_CONFIGURATION_TABS.EARNING_LIMIT_PERIOD) {
        const data = earningLimitPeriodList.find(item => item.id === id);

        setTempId(data.id);
        setTempStatus(data.status);
        setShowUpdateStatus(true);
      }




    }
  };

  const RefreshData = () => {
    getData(tabStatus);
  };




  const handleCreateAction = () => {
    if (tab == REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER) {
      navigate(ADMIN_TOOLS_CAMPAIGN_REWARD_PROVIDER_CREATE);
    }
    if (tab == REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY) {
      navigate(ADMIN_TOOLS_CAMPAIGN_CATEGORY_CREATE);
    }
  };

  const iconsWithAdd = [
    ...(AddPermssion ? [{
      buttonName: "+ Add new",
      action: handleCreateAction,
    }] : []),
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
  ];

  const icons = [
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    },
  ];

  const updateStatus = () => {

    let params = { id: tempId, is_active: tempStatus == "Active" ? true : false };
    setTempId("");
    setTempStatus("");
    setShowUpdateStatus(false);

    if (tab == REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION) {
      dispatch(updateModuleConfigurationStatus({ data: params, id: tempId })).then((res) => {
        if (res.payload.status_code === 200) {
          getData();
        } else {
          alert(res.payload.message);
        }
      });
    } else if (tab == REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY) {
      dispatch(updateCampaignCategoryStatus({ data: params, id: tempId })).then((res) => {
        if (res.payload.status_code === 200) {
          getData();
        } else {
          alert(res.payload.message);
        }
      });
    }
    else if (tab == REWARD_CONFIGURATION_TABS.EARNING_LIMIT_PERIOD) {
      dispatch(updateEarningLimitPeriodStatus({ data: params, id: tempId })).then((res) => {
        if (res.payload.status_code === 200) {
          getData();
        } else {
          alert(res.payload.message);
        }
      });
    }


  };


  const onTabChange = (tab) => {
    setTab(tab);
  };

  const renderTable = () => {

    if (tab == REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION) {
      return <Reusable_table
        key={moduleConfigurationList.length}
        header={ConfigDataForModuleConfiguration}
        data={moduleConfigurationList}
        pagination={true}
        calculatePagi={true}
        pageChangeLoading={false}
        showRow={true}
        checkbox={false}
        handleAction={handleTableClick}
        maxHeight={"calc(-221px + 100vh)"}
        maxWidth={"calc(100vw - 240px)"}
      />;
    } else if (tab == REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER) {
      return <Reusable_table
        key={rewardProviderList.length}
        header={ConfigDataForRewardProvider}
        data={rewardProviderList}
        pagination={true}
        calculatePagi={true}
        pageChangeLoading={false}
        showRow={true}
        checkbox={false}
        handleAction={handleTableClick}
        maxHeight={"calc(-221px + 100vh)"}
        maxWidth={"calc(100vw - 240px)"}
      />;
    } else if (tab == REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY) {
      return <Reusable_table
        key={campaignCategoryList.length}
        header={ConfigDataForCampaignCategory}
        data={campaignCategoryList}
        pagination={true}
        calculatePagi={true}
        pageChangeLoading={false}
        showRow={true}
        checkbox={false}
        handleAction={handleTableClick}
        maxHeight={"calc(-221px + 100vh)"}
        maxWidth={"calc(100vw - 240px)"}
      />;
    } else if (tab == REWARD_CONFIGURATION_TABS.EARNING_LIMIT_PERIOD) {
      return <Reusable_table
        key={earningLimitPeriodList.length}
        header={ConfigDataForEarningLimitPeriod}
        data={earningLimitPeriodList}
        pagination={true}
        calculatePagi={true}
        pageChangeLoading={false}
        showRow={true}
        checkbox={false}
        handleAction={handleTableClick}
        maxHeight={"calc(-221px + 100vh)"}
        maxWidth={"calc(100vw - 240px)"}
      />;
    } else if (tab == REWARD_CONFIGURATION_TABS.GLOBAL_CONFIG) {
      return <Reusable_table
        key={globalPeriodList.length}
        header={ConfigDataForGlobalConfig}
        data={globalPeriodList}
        pagination={true}
        calculatePagi={true}
        pageChangeLoading={false}
        showRow={true}
        checkbox={false}
        handleAction={handleTableClick}
        maxHeight={"calc(-221px + 100vh)"}
        maxWidth={"calc(100vw - 240px)"}
      />;
    }

    return <Reusable_table
      key={moduleConfigurationList.length}
      header={ConfigDataForModuleConfiguration}
      data={moduleConfigurationList}
      pagination={true}
      calculatePagi={true}
      pageChangeLoading={false}
      showRow={true}
      checkbox={false}
      handleAction={handleTableClick}
      maxHeight={"calc(-221px + 100vh)"}
      maxWidth={"calc(100vw - 240px)"}
    />;
  }



  return (
    <>
      {viewPermssion ? (
        <div className="container">


          {showUpdateStatus && (
            <ShowDialog
              cancelbtn={() => {
                setShowUpdateStatus(false);
                setTempStatus("");
              }}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={["Active", "Inactive"]}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          <TableHeader title={"Campaign Configuration"} icons={(tab == REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER || tab == REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY) ? iconsWithAdd : icons} />
          {showDelete && (
            <ShowDialog
              title={"Please Confirm!"}
              content={"Are you sure you want to delete?"}
              cancelContent={"Cancel"}
              confrimContent={"Delete"}
              cancelbtn={() => setShowDelete(false)}
              confrinbtn={actionTrigger}
            />
          )}

          {(<div className="campaign-configuration-list-box">
            <div className="campaign-configuration-list-container">
              <div className="tabs">
                <div
                  onClick={() => {
                    onTabChange(REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION);
                  }}
                  className={`tab ${tab === REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION ? "isactive" : ""
                    }`}
                >
                  {REWARD_CONFIGURATION_TABS.MODULE_CONFIGURATION}
                </div>
                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>

                <div
                  onClick={() => {
                    onTabChange(REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER);

                  }}
                  className={`tab ${tab === REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER ? "isactive" : ""
                    }`}
                >
                  {REWARD_CONFIGURATION_TABS.REWARDS_PROVIDER}
                </div>

                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>

                <div
                  onClick={() => {
                    onTabChange(REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY);

                  }}
                  className={`tab ${tab === REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY ? "isactive" : ""
                    }`}
                >
                  {REWARD_CONFIGURATION_TABS.CAMPAIGN_CATEGORY}
                </div>

                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>

                <div
                  onClick={() => {
                    onTabChange(REWARD_CONFIGURATION_TABS.EARNING_LIMIT_PERIOD);
                  }}
                  className={`tab ${tab === REWARD_CONFIGURATION_TABS.EARNING_LIMIT_PERIOD ? "isactive" : ""
                    }`}
                >
                  {REWARD_CONFIGURATION_TABS.EARNING_LIMIT_PERIOD}
                </div>

                <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>

                <div
                  onClick={() => {
                    onTabChange(REWARD_CONFIGURATION_TABS.GLOBAL_CONFIG);
                  }}
                  className={`tab ${tab === REWARD_CONFIGURATION_TABS.GLOBAL_CONFIG ? "isactive" : ""
                    }`}
                >
                  {REWARD_CONFIGURATION_TABS.GLOBAL_CONFIG}
                </div>




              </div>
            </div>

            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) : (
              renderTable()
            )}
          </div>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
